import React from 'react';
import './HomeServicesGrid.css';
import { FaArrowRight, FaCheckCircle, FaStar, FaClock, FaShieldAlt } from 'react-icons/fa';
import sImage from '../../assets/s.png';

const HomeServicesGrid = () => {
  const services = [
    { name: 'Dry Cleaning', icon: '👔', description: 'Professional care for delicate garments' },
    { name: 'Laundry', icon: '🧺', description: 'Fresh, clean clothes every time' },
    { name: 'Leather Cleaning', icon: '🧥', description: 'Expert leather care and restoration' },
    { name: 'Curtain Cleaning', icon: '🪟', description: 'Spotless curtains and drapes' },
    { name: 'Steam Iron', icon: '♨️', description: 'Perfectly pressed garments' },
    { name: 'Carpet & Sofa', icon: '🛋️', description: 'Deep cleaning for upholstery' },
    { name: 'Shoe Cleaning', icon: '👟', description: 'Restore your footwear to new' },
    { name: 'Upholstery', icon: '🪑', description: 'Complete furniture care' }
  ];

  return (
    <section className="home-services-grid">
      <div className="services-grid-container">
        <div className="services-grid-header">
          <h2>Complete Cleaning Solutions</h2>
          <p className="services-grid-subtitle">
            From everyday laundry to specialized cleaning services, we handle it all with professional expertise and care.
          </p>
        </div>

        <div className="services-grid-layout">
          <div className="services-visual-section">
            <div className="central-image">
              <img src={sImage} alt="NeatnClean Logo" className="main-logo-image" />
            </div>
          </div>

          <div className="services-content-section">
            <div className="content-highlights">
              <div className="highlight-card">
                <div className="highlight-icon">
                  <FaCheckCircle />
                </div>
                <div className="highlight-text">
                  <h4>8 Specialized Services</h4>
                  <p>Comprehensive cleaning solutions for every need</p>
                </div>
              </div>

              <div className="highlight-card">
                <div className="highlight-icon">
                  <FaStar />
                </div>
                <div className="highlight-text">
                  <h4>Expert Care</h4>
                  <p>Professional techniques for optimal results</p>
                </div>
              </div>

              <div className="highlight-card">
                <div className="highlight-icon">
                  <FaClock />
                </div>
                <div className="highlight-text">
                  <h4>Quick Turnaround</h4>
                  <p>Fast service without compromising quality</p>
                </div>
              </div>

              <div className="highlight-card">
                <div className="highlight-icon">
                  <FaShieldAlt />
                </div>
                <div className="highlight-text">
                  <h4>Safe & Secure</h4>
                  <p>Your items are protected throughout the process</p>
                </div>
              </div>
            </div>

            {/* <div className="cta-section">
              <h3>Ready to Experience Professional Cleaning?</h3>
              <p>Book any of our services today and see the NeatnClean difference!</p>
              <button className="cta-button">
                Book Now <FaArrowRight />
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeServicesGrid;
